import { Typography } from '@mui/material';

interface ModalTitleProps {
  variant?: 'dark' | 'light';
  children: React.ReactNode;
}

export const ModalTitle = ({ variant = 'dark', children }: ModalTitleProps) => (
  <Typography sx={[styles[variant]]} variant="h3">
    {children}
  </Typography>
);

const styles = {
  dark: { color: 'text.main' },
  light: { color: 'text.contrast' },
};
